/**
 * Resolve a media path returned by the API into an absolute URL.
 *
 * The API serialises empty Django FileFields as `null`, not `""` — DRF's
 * FileField.to_representation returns None for any falsy value. Most payment
 * proofs have no ID document (255 of 277 in production), so calling
 * `.startsWith()` straight on these fields crashes the page for the majority
 * of records.
 *
 * Returns null when there is nothing to show, so callers must handle the empty
 * case explicitly instead of rendering a broken image.
 */
export function mediaUrl(path?: string | null): string | null {
  if (!path) return null;
  return path.startsWith("http") ? path : `${window.location.origin}${path}`;
}

/** Open a media file in a new tab. No-op when the file is absent. */
export function openMedia(path?: string | null): void {
  const url = mediaUrl(path);
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
}
